import React from "react";
import { Camera, Calendar, FileText, Users } from "lucide-react";
import "./css/CareerPrep.css";

const CareerPrep = () => {
    return (
        <div className="career-prep-section">
            <div className="container">
                <div className="row header-row">
                    <div className="col-lg-8 col-md-8">
                        <h2 className="section-headings">Guided Learning & Development</h2>
                        <p className="section-description">
                            For each milestone, we provide
                            - Curated video courses from industry experts
                            - Recommended books and resources
                            - Scheduled mentorship sessions
                            - Skills assessments
                            - Industry events and networking opportunities

                        </p>
                        <a href="/subscription"><button className="btn btn-primary try-free-btn">Get Started Now</button></a>
                    </div>
                    <div className="col-lg-4 col-md-4">
                        <div className="rating-cards-container">
                            <div className="rating-card">
                                <h3 className="rating-value">4.7/5</h3>
                                <p className="rating-label">Avg Mentorship Rating</p>
                            </div>
                            <div className="rating-card program-support">
                                <h3 className="rating-value">1:1</h3>
                                <p className="rating-label">Program Support</p>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row career-feature">
                    <div className="col-lg-4">
                        <div className="feature-image">
                            <img src="../../../images/team/thumb-3.jpg" alt="Career Mentoring Session" />
                        </div>
                    </div>
                    <div className="col-lg-8">
                        <div className="feature-content">
                            <h3 className="feature-title">1 : 1 Career mentoring</h3>
                            <ul className="feature-list">
                                <li>
                                    <span className="bullet"></span>
                                    1:1 LIVE online sessions with experienced industry professionals
                                </li>
                                <li>
                                    <span className="bullet"></span>
                                    Expert mentors guide you on the career path that's right for you
                                </li>
                                <li>
                                    <span className="bullet"></span>
                                    Suggestions on setting your short term and long term career goals
                                </li>
                                <li>
                                    <span className="bullet"></span>
                                    Mentors from various domains help you gain valuable industry insights
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div className="row career-feature">
                    <div className="col-lg-4">
                        <div className="feature-image">
                            <img src="../../../images/about/resume.png" alt="CV and LinkedIn Review" />
                        </div>
                    </div>
                    <div className="col-lg-8">
                        <div className="feature-content">
                            <h3 className="feature-title">CV/LinkedIn Review</h3>
                            <ul className="feature-list">
                                <li>
                                    <span className="bullet"></span>
                                    Feedback from experts to make your resume and LinkedIn profiles stand out from the crowd
                                </li>
                                <li>
                                    <span className="bullet"></span>
                                    Personalized and detailed suggestions to improve the content and format of your CV
                                </li>
                                <li>
                                    <span className="bullet"></span>
                                    Tips on customizing your resume for the job profile you are applying to
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div className="row career-feature">
                    <div className="col-lg-4">
                        <div className="feature-image">
                            <img className="img-fluid analysis-img" src="../../../images/about/analysis.jpg" alt="Interview Preparation" />
                        </div>
                    </div>
                    <div className="col-lg-8">
                        <div className="feature-content">
                            <h3 className="feature-title">Video Interview Analysis</h3>
                            <ul className="feature-list">
                                <li>
                                    <span className="bullet"></span>
                                    1:1 mock interviews with industry experts to help you land your dream job
                                </li>
                                <li>
                                    <span className="bullet"></span>
                                    Guidance from our alumni currently in roles you aspire for
                                </li>
                                <li>
                                    <span className="bullet"></span>
                                    Develop industry context with case studies and learn answers to common technical and HR questions
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CareerPrep;